import { useEffect } from 'react';
import authTokenUtil from '../account/authTokenUtil';
import type { MessageEmbedAuthToken } from '../constants/messages';
import { MESSAGE_EMBED_AUTH_TOKEN } from '../constants/messages';

const useEmbedAuthListener = () => {
  useEffect(() => {
    const isInIframe = window.self !== window.top;

    if (typeof BroadcastChannel === 'undefined' || !isInIframe) {
      return undefined;
    }

    // Use BroadcastChannel to communicate with other iframes on the same site
    // Can't replace postMessage since BC could be blocked/partitioned
    const sameTopLevelBC = new BroadcastChannel(MESSAGE_EMBED_AUTH_TOKEN);
    sameTopLevelBC.onmessage = () => {
      window.location.reload();
    };

    const postMessageListener = (
      event: MessageEvent<MessageEmbedAuthToken>,
    ) => {
      if (event.origin !== window.location.origin) return;

      if (event.data?.type === MESSAGE_EMBED_AUTH_TOKEN && event.data.token) {
        authTokenUtil.set(event.data.token);

        if (event.source && 'close' in event.source) {
          event.source.close();
        }

        sameTopLevelBC.postMessage({});
        window.location.reload();
      }
    };

    window.addEventListener('message', postMessageListener);

    return () => {
      sameTopLevelBC.close();
      window.removeEventListener('message', postMessageListener);
    };
  }, []);
};

export default useEmbedAuthListener;
